import { Link } from "react-router-dom";
import { Instagram } from "lucide-react";
import { AgencyLogo } from "@/components/Navbar";
import { useLanguage } from "@/context/LanguageContext";

export const Footer = () => {
  const { t } = useLanguage();

  const DIVISIONS = [
    { to: "/models", label: t("footer.models") },
    { to: "/actors", label: t("footer.actors") },
    { to: "/voice", label: t("footer.voice") },
    { to: "/new-faces", label: t("footer.newFaces") },
  ];
  const ENQUIRIES = [
    { to: "/clients", label: t("footer.bookings") },
    { to: "/discover", label: t("footer.discovery") },
    { to: "/submissions", label: t("footer.submissions") },
    { to: "/contact", label: t("footer.contact") },
  ];
  const SOCIALS = [
    { href: t("social.instagram"), label: "Instagram", Icon: Instagram, testid: "social-instagram" },
  ];

  return (
    <footer data-testid="site-footer" className="border-t border-white/10">
      <div className="mx-auto max-w-[1800px] px-4 pt-16 sm:px-8 lg:px-16">
        <div className="grid gap-12 md:grid-cols-12">
          <div className="md:col-span-5">
            <div className="flex items-center gap-3">
              <AgencyLogo className="h-16 w-auto" />
            </div>
            <p className="mt-5 max-w-sm font-display text-xl font-light italic leading-relaxed text-white/70">
              {t("footer.tagline")}
            </p>
            <div className="mt-6 flex gap-3">
              {SOCIALS.map(({ href, label, Icon, testid }) => (
                <a key={testid} href={href} target="_blank" rel="noreferrer" data-testid={testid} aria-label={label} className="flex h-9 w-9 items-center justify-center border border-white/15 text-white/60 transition-colors hover:border-gold hover:text-gold">
                  <Icon className="h-4 w-4" />
                </a>
              ))}
            </div>
          </div>
          <div className="md:col-span-2">
            <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-gold">{t("footer.divisions")}</div>
            <ul className="mt-5 space-y-3">
              {DIVISIONS.map((l) => (
                <li key={l.to}>
                  <Link to={l.to} className="text-sm text-white/60 transition-colors hover:text-white">
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          <div className="md:col-span-2">
            <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-gold">{t("footer.enquiries")}</div>
            <ul className="mt-5 space-y-3">
              {ENQUIRIES.map((l) => (
                <li key={l.to}>
                  <Link to={l.to} className="text-sm text-white/60 transition-colors hover:text-white">
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          <div className="md:col-span-3">
            <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-gold">{t("footer.headquarters")}</div>
            <div className="mt-5 space-y-2 font-mono text-xs leading-relaxed text-white/60">
              <div>{t("footer.city")}</div>
              <div>{t("site.email")}</div>
            </div>
            <Link
              to="/submissions"
              data-testid="footer-submissions-link"
              className="mt-6 inline-block border border-white/20 px-5 py-2.5 font-mono text-[10px] uppercase tracking-[0.25em] text-white/70 transition-colors hover:border-gold hover:text-gold"
            >
              {t("footer.apply")}
            </Link>
          </div>
        </div>

        <div className="mt-16 select-none overflow-hidden" aria-hidden="true">
          <div
            className="whitespace-nowrap text-center font-display text-[5.5vw] font-light uppercase leading-[0.95] tracking-tight text-transparent"
            style={{ WebkitTextStroke: "1px rgba(250,248,245,0.16)" }}
          >
            DIAMOTIMS AGENCY
          </div>
        </div>

        <div className="flex flex-col items-start justify-between gap-2 border-t border-white/10 py-6 font-mono text-[10px] uppercase tracking-[0.25em] text-white/40 sm:flex-row sm:items-center">
          <span>{t("footer.copyright")}</span>
          <span>{t("footer.city")}</span>
        </div>
      </div>
    </footer>
  );
};
